'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var BaseHeader = require('@narvar/nth-bundle-dynamic-header');
var nthHookSettings = require('@narvar/nth-hook-settings');
var useTrackSettings = require('../../../portals/customer/providers/useTrackSettings.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var BaseHeader__default = /*#__PURE__*/_interopDefaultLegacy(BaseHeader);

// Look at the header on the assist product first and use that value
// Fallback to getting the header from the track product
const HeaderWithSettings = () => {
  const {
    trackHeader
  } = nthHookSettings.useSettings();
  if (trackHeader !== null && trackHeader !== void 0 && trackHeader.html) {
    return /*#__PURE__*/React__default["default"].createElement(BaseHeader__default["default"], null);
  }
  return /*#__PURE__*/React__default["default"].createElement(useTrackSettings.LomaTrackSettingsProvider, null, /*#__PURE__*/React__default["default"].createElement(BaseHeader__default["default"], null));
};
var Header = nthHookSettings.withSettingsProvider(HeaderWithSettings, {
  settingsRequested: `
    trackHeader {
      html
      querySelectors
      sticky
    }
  `
});

exports["default"] = Header;
